import { useCallback } from 'react';
import { useRouter } from '@repo/ui/hooks/use-router';

interface UseDetailsArbreActionsProps {
  inventaireId: number;
}

export function useDetailsArbreActions({ inventaireId }: UseDetailsArbreActionsProps) {
  const router = useRouter();

  const handleEdit = useCallback(() => {
    router.push(`/admin/inventaires/${inventaireId}/arbre/edit`);
  }, [inventaireId, router]);

  const handlePrint = useCallback(() => {
    router.push(`/admin/inventaires/${inventaireId}/arbre/print`);
  }, [inventaireId, router]);

  const handleIntervention = useCallback(() => {
    router.push(`/admin/inventaires/${inventaireId}/arbre/intervention`);
  }, [inventaireId, router]);

  const handleDelete = useCallback(() => {
    // TODO: Implement delete with confirmation dialog
    console.log('Delete with confirmation');
  }, []);

  return {
    handleEdit,
    handlePrint,
    handleIntervention,
    handleDelete,
  };
}

